import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Label } from "@progress/kendo-react-labels";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import styles from "./index.module.scss";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { useState } from "react";
import { useSelector } from "react-redux";
import { addDirector } from "api";
import { toast } from "react-toastify";
import { FormInput } from "components/Matters";

const AddDirectors = (props) => {
  const [date, setDate] = useState(new Date());
  const [notes, setNotes] = useState(props.item?.details || "");
  const [inputState, setInputState] = useState({});
  const [isEdited, setIsEdited] = useState(false);
  const handleInputChange = (value, label) => {
    setInputState({
      ...inputState,
      [label]: value,
    });
  };

  const handleSubmit = async () => {
    try {
      const data = {
        firstName: inputState["First_Name"],
        lastName: inputState["Last_Name"],
        dateOfBirth: date,
        personType: "director",
      };
      const resultData = await addDirector({ data: data }, props.clientId);
      toast.success("Director Added");
      props.onUpdateData(resultData?.data?.data);
      props.cancelEdit();
    } catch (error) {
      toast.error("Unexpected Error Occured");
    }
  };

  return (
    <Dialog
      title={"Add Director"}
      onClose={props.cancelEdit}
      width={500}
      className="p-3"
    >
      <div className={`${styles["director-tile"]} p-2 m-4 ms-5 me-5`}>
        <div className="p-3 ps-4">
          <div className="form-date-picker note-date-picker mt-2">
            <FormInput
              className={"form-date-picker note-date-picker "}
              wf={true}
              isStyled={true}
              width={"260px"}
              label={"First_Name"}
              onChangeInput={handleInputChange}
              state={inputState}
            />
          </div>

          <div className="mt-3">
            <FormInput
              className={"form-date-picker note-date-picker "}
              wf={true}
              isStyled={true}
              width={"260px"}
              label={"Last_Name"}
              onChangeInput={handleInputChange}
              state={inputState}
            />
          </div>

          <div className="form-date-picker note-date-picker mt-3">
            <Label className="label mt-1 mb-1 w-100">Date&nbsp;</Label>
            <DatePicker
              toggleButton={CalenderCustomToggleButton}
              onChange={(e) => {
                setDate(e.value);
              }}
              value={date}
              className="px-1"
              style={{
                height: "32px",
                width: "260px",
              }}
            />
          </div>
        </div>
      </div>
      <div className="dialog-footer">
        <button
          className="bgBtnSecondary common-btn me-2"
          onClick={() => {
            if (isEdited) {
              setIsEdited(false);
            } else {
              props.cancelEdit();
            }
          }}
        >
          Cancel
        </button>
        <button
          className="common-btn me-3"
          onClick={() => {
            handleSubmit();
          }}
        >
          {"Save"}
        </button>
      </div>
    </Dialog>
  );
};

export default AddDirectors;
